// removed by extract-text-webpack-plugin
module.exports = {"flex":"theme--flex--3UzAYu4e","center":"theme--center--2Nr-jGS5","stretch":"theme--stretch--2Ff4cURx","between":"theme--between--gMk5ke83","inline-flex":"theme--inline-flex--1Le2YyaE","inlineFlex":"theme--inline-flex--1Le2YyaE"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/sign/baseComponents/FlexContainer/theme.scss
// module id = 810
// module chunks = 0